import { useHistory, useParams } from "react-router-dom";
import { formatDate } from "../../utils";
import { IVisit } from "../../interfaces";
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../config";
import { get } from "../../_api";
import {
  Anchor,
  Badge,
  Button,
  List,
  Stack,
  Text,
  Title,
} from "@mantine/core";

const VisitDetails: React.FC = () => {
  const { id }: { id: string } = useParams();
  const [visit, setVisit] = useState<IVisit | null>(null);
  const [files, setFiles] = useState<string[]>([]);
  const history = useHistory();

  useEffect(() => {
    get("visits/" + id).then((data) => {
      setVisit(data);
    });
  }, [id]);

  useEffect(() => {
    if (visit?.client) {
      get("file/" + visit?.client._id).then((data) => {
        setFiles(data);
      });
    }
  }, [visit?.client]);

  const handleRemove = () => {
    if (window.confirm("Czy na pewno usunąć? Operacji nie można cofnąć!")) {
      axios
        .delete(API + "/visits/" + id)
        .then(() => {
          history.push("/");
        })
        .catch((e) => console.log(e));
    }
  };

  return (
    <Stack gap="lg" maw={1200} mx="auto" px="md" pb={250}>
      <Button variant="default" onClick={() => history.goBack()}>
        ⟵ WSTECZ
      </Button>
      {visit && (
        <Stack gap="md">
          <Stack gap="xs">
            <Title order={1}>
              Termin:{" "}
              <Text span inherit fw={700}>
                {formatDate(new Date(visit.date))}
              </Text>
            </Title>
            <Title order={2}>
              Kwota:{" "}
              <Text span inherit fw={700}>
                {visit.amount ? visit.amount : "400"}
              </Text>{" "}
              PLN
            </Title>
            <Text>
              {visit.status === "in-progress" && "Etap: Wstępna rezerwacja"}
              {visit.status === "reserved" && "Etap: Klient uzupełnił dane"}
            </Text>
            <div>
              {visit.payment?.status === "in-progress" && (
                <Text>Status płatności: Oczekująca</Text>
              )}
              {visit.payment?.status === "completed" && (
                <Badge color="green" variant="light">
                  Status płatności: Płatność zakończona (sukces)
                </Badge>
              )}
              {visit.payment?.status === "new" && (
                <Text>Status płatności: Płatność rozpoczęta</Text>
              )}
              {visit.payment?.status === "rejected" && (
                <Badge color="red" variant="light">
                  Status płatności: Płatność odrzucona
                </Badge>
              )}
            </div>
          </Stack>
          {visit.client && (
            <Stack gap="sm">
              <Text>Imię i nazwisko: {visit.client.name}</Text>
              <Text>Telefon: {visit.client.phone}</Text>
              <Text>Firma: {visit.client.company}</Text>
              <Text>
                Adres e-mail:{" "}
                <Anchor href={`mailto:${visit.client.email}`}>
                  {visit.client.email}
                </Anchor>
              </Text>
              <Text style={{ whiteSpace: "pre-wrap" }}>
                {visit.client.description}
              </Text>
              <List spacing="sm" listStyleType="disc" pl="md" size="sm">
                {files.map((el, i) => (
                  <List.Item key={`${el}-${i}`}>
                    <Text component="span" c="dark.7" size="sm" lh={1.5}>
                      {el}
                    </Text>
                  </List.Item>
                ))}
              </List>
            </Stack>
          )}
          <Button color="red" onClick={handleRemove}>
            Usuń
          </Button>
        </Stack>
      )}
    </Stack>
  );
};

export default VisitDetails;
